import { useAppSelector } from 'app/state'
import { Map, MapPrivacy } from 'features/maps/types'
import { hasEditionRole } from 'features/users/model/user'

export default function useMapSharingInfo(map?: Partial<Map>) {
  const me = useAppSelector((state) => state.users.me)

  const isSharedMap = map?.token != null && map?.privacy === MapPrivacy.Shared
  const isPublicMap = map?.token != null && map?.privacy === MapPrivacy.Public
  const isEditable = Boolean(me && map && (map.ownerId === me.user_id || (map.collaborative && hasEditionRole(me))))
  const isMapOwner = Boolean(me && map && map.ownerId === me.user_id)

  return { isSharedMap, isPublicMap, isEditable, isMapOwner }
}
